import { ConnectionHandler } from "relay-runtime"

const bodyMeasurementConnectionKey = "PatientByIdConnection_bodyMeasurements"

export const getBodyMeasurementConnectionId = (patientId: string) => {
  return ConnectionHandler.getConnectionID(patientId, bodyMeasurementConnectionKey)
}
